import * as Sentry from '@sentry/react'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useClientSetting } from 'src/clientSetting/Provider'
import { getLoginPharmacyUid } from './loginPharmacyUid'

export const useClientTags = () => {
  const client = useClientSetting()
  const router = useRouter()
  const loginPharmacyUid = getLoginPharmacyUid(router.query)

  useEffect(() => {
    Sentry.setTag('clientId', client.id)
    return () => {
      Sentry.setTag('clientId', null)
    }
  }, [client.id])

  useEffect(() => {
    Sentry.setTag('loginPharmacyUid', loginPharmacyUid)
    return () => {
      Sentry.setTag('loginPharmacyUid', null)
    }
  }, [loginPharmacyUid])
}
